import React from 'react';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Grid2 from '@mui/material/Grid2';
import { Card, CardActionArea } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import ExtensionIcon from '@mui/icons-material/Extension';

const gettingStartedItems = [
  {
    name: 'Browse the Catalog',
    description: 'Explore registered services, APIs, and resources.',
    icon: CategoryIcon,
    link: '/catalog',
  },
  {
    name: 'Read the Docs',
    description: 'Browse TechDocs for systems and components.',
    icon: LibraryBooksIcon,
    link: '/docs',
  },
  {
    name: 'Explore APIs',
    description: 'Discover and try out registered APIs.',
    icon: ExtensionIcon,
    link: '/api-docs',
  },
];

const GettingStarted = () => {
  return (
    <Grid2
      container
      spacing={2}
      wrap="wrap"
      justifyContent="center"
      columns={12}
    >
      {gettingStartedItems.map(item => (
        <Grid2
          key={item.name}
          size={3}
          display="flex"
          justifyContent="center"
        >
          <Card sx={{
            width: 250,
            height: 220,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}>
            <CardActionArea
              href={item.link}
              sx={{
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                justifyContent: "flex-start",
                padding: 2,
              }}
            >
              <item.icon sx={{ fontSize: 48, marginTop: 2, color: "primary.main" }} />
              <CardContent sx={{ flexGrow: 1, textAlign: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ color: "text.primary", fontWeight: 600 }}
                >
                  {item.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "text.secondary" }}
                >
                  {item.description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid2>
      ))}
    </Grid2>
  );
};

export default GettingStarted;
